<template>
  <v-card
    class="mx-auto px-6 mt-0 card-info"
    :loading="isLoading"
    max-width="620"
    min-width="450"
    min-height="300"
    elevation="2"
  >
    <div class="billing-header text-center font-weight-bold pt-6">
      Billing Details
    </div>
    <v-container fluid>
      <v-row
        v-if="paymentMethod"
        class="mt-2"
        justify="space-around"
      >
        <v-col cols="6">
          <div class="card-subheader">
            Payment Method
          </div>
          <v-card
            class="mt-0 px-3 py-2"
            height="82"
            rounded="t-0"
            outlined
          >
            <p class="font-weight-bold">
              {{ cardDisplayName }}
            </p>
            <p class="font-weight-bold">
              {{ paymentMethod.name }}
            </p>
            <p>
              Card # ....{{ card.last4 }}
            </p>
          </v-card>
        </v-col>
        <v-col cols="6">
          <div class="card-subheader">
            Billing Address
          </div>
          <v-card
            class="mt-0 px-3 py-2"
            height="82"
            rounded="t-0"
            outlined
          >
            <p>
              {{ address.address1 }}
            </p>
            <p>
              {{ address.address2 }}
            </p>
            <p>
              {{ address.city }}, {{ address.state }} {{ address.postalCode }}
            </p>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-else
        justify="center"
        class="mt-6"
      >
        <div>
          No payment methods on file for this organization.
        </div>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="text-center"
        >
          <router-link
            :to="{path: '/billing/edit'}"
            class="billing-link"
          >
            {{ updateMessage }}
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { cardTypes } from '@/helpers/billing-helper'

  export default {
    name: 'CardInfo',
    data () {
      return {
        isLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        canUpdateBilling: 'Billing/currentOrgBillingEnabled',
        paymentMethod: 'Billing/defaultPaymentMethod',
      }),
      address () {
        return this.paymentMethod.billingAddress
      },
      card () {
        return this.paymentMethod.cardInfo
      },
      cardDisplayName () {
        return cardTypes[this.card.brand]
      },
      updateMessage () {
        if (this.paymentMethod) {
          return 'Replace Payment Method'
        } else {
          return 'Add Payment Method'
        }
      },
    },
    watch: {
      currentSelectedOrg () {
        this.handleOrgUpdate()
      },
    },
    created () {
      this.handleOrgUpdate()
    },
    methods: {
      handleOrgUpdate () {
        if (this.canUpdateBilling) {
          this.getPaymentMethods()
        }
      },
      getPaymentMethods () {
        this.isLoading = true

        this.$store.dispatch('Billing/getPaymentMethods', this.currentSelectedOrg.id)
          .finally(() => {
            this.isLoading = false
          })
      },
    },
  }
</script>
<style lang="scss">
  .card-info {
    font-size: 12px;

    .billing-header {
      font-size: 18px;
    }

    .card-subheader {
      background-color: $na-medium-grey;
      color: #ffffff;
      font-weight: bold;
      padding: 4px 0 4px 8px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    p {
      margin-bottom: 4px;
    }
  }
</style>
